import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AvatarSettingsContent } from "./AvatarSettingsContent";
import {
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Subtitle1,
  makeStyles,
  Button,
  OverlayDrawer,
  DrawerHeaderTitle,
  DrawerBody,
  Drawer,
  DrawerHeader
} from "@fluentui/react-components";
import { Dismiss20Regular, ArrowLeftRegular, CubeRotateRegular } from "@fluentui/react-icons";
import styles from "./AvatarSetupModal.scss";
import useBreakpoints from "../hooks/useBreakpoints";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "100%",
    paddingBottom: "0px!important",
    marginBottom: "24px!important"
  },
  titleContainer: {
    display: "flex",
    gap: "8px"
  }
});

export function AvatarSetupModal({ className, onBack, history, mediaSource, onSubmit, ...rest }) {
  const classes = useStyles();
  const breakpoint = useBreakpoints();

  const [open, setIsOpen] = useState(true);

  if (mediaSource === "avatars") return <></>;

  const callbackOpen = async cb => {
    setIsOpen(false);
    setTimeout(() => {
      cb();
    }, 100);
  };

  return (
    <OverlayDrawer
      position={["xs", "sm", "md"].includes(breakpoint) ? "bottom" : "end"}
      open={open}
      modalType="non-modal"
      className={styles.entryCard}
    >
      <DrawerHeader style={{ width: "100%" }}>
        <DrawerHeaderTitle className={classes.titleContainer}>
          <Button
            onClick={() => callbackOpen(onBack)}
            style={{ height: "30px", width: "30px", marginRight: "10px" }}
            icon={<ArrowLeftRegular style={{ width: "18px" }} />}
          ></Button>
          <Subtitle1>
            <FormattedMessage id="audio-debug-panel.audio-debug-avatar-title" defaultMessage="Avatar" />
          </Subtitle1>
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody className={classes.dialogContent}>
        <AvatarSettingsContent callbackOpen={callbackOpen} onSubmit={onSubmit} {...rest} />
      </DrawerBody>
    </OverlayDrawer>
  );
}

AvatarSetupModal.propTypes = {
  className: PropTypes.string,
  onBack: PropTypes.func
};
